module.exports = __webpack_public_path__ + "static/media/RequestTelemedicine.e245b14a.svg";